module.exports = __webpack_public_path__ + "static/media/pause-event.0cc3fb2d.svg";